import { EnumMenuAcoes } from "../Cards";
import { MenuAcao, TipoExibicao } from "../MenuItemAcao"
import { Projeto, ProjetoTipoType } from "../types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import moment from "moment";
import { POTENCIA_MINIMA_ENGENHARIA, TIPO_SERVICO_TURNKEY } from "../constants";
import { SEGMENTO_PROJETO } from "../historico/HistoricoMigrado/utils/constants";
import { Pedido } from "src/components/vendas/types";

export enum EnumSituacaoProjeto {
  FINALIZADO = "finalizado",
  PENDENTE = "pendente",
  CANCELADO = "cancelado",
  PAUSADO = "pausado",
  EXPIRADO = "expirado",
}

export enum EnumSituacaoPedido {
  PENDENTE = "pendente",
  FINALIZADO = "finalizado",
  CANCELADO = "cancelado",
}

export enum EnumEtapaVenda {
  SLA_ENGENHARIA = "sla_engenharia",
  PRE_ORCAMENTO = "pre_orcamento",
  PROPOSTA_FINAL = "proposta_final",
  AGUARDANDO_PAGAMENTO = "aguardando_pagamento",
  NEGOCIACAO = "negociacao",
  AGUARDANDO_FATURAMENTO = "aguardando_faturamento",
  FATURADO = "faturado",
  EM_TRANSITO = "em_transito",
  ENTREGUE = "entregue"
}

export enum STATUS_PROJETO {
  PRE_ORCAMENTO = "pre_orcamento",
  PROPOSTA_FINAL = "proposta_final",
  PAGAMENTO_APROVADO = "pagamento_reconhecido",
  PROCESSANDO_INFO_PEDIDO = "processando_informacoes_pedido",
  EM_TRANSITO = "em_transito",
  ENTREGUE = "entregue",
  FINALIZADO = "finalizado",
  CANCELADO = "cancelado",
  EXPIRADO = "expirado",
}

export const STATUS_REENVIAR_NF: string[] = [
  STATUS_PROJETO.PAGAMENTO_APROVADO, 
  STATUS_PROJETO.PROCESSANDO_INFO_PEDIDO,
  STATUS_PROJETO.EM_TRANSITO, 
  STATUS_PROJETO.ENTREGUE, 
  STATUS_PROJETO.FINALIZADO
];

export const STATUS_ATUALIZAR_ENTREGA: string[] = [
  STATUS_PROJETO.PAGAMENTO_APROVADO, 
  STATUS_PROJETO.PROCESSANDO_INFO_PEDIDO, 
  STATUS_PROJETO.EM_TRANSITO
];

const potMinimaSolicitarRevisaoComServ = 112.5; //verificar para colocar em parâmetro se tiver serviço junto
const tipoVertical = 'vertical';
const tipoKit = 'kit';
export const tipoAvulso = 'avulso';

export const checarStatusAcao = (acao: MenuAcao, projeto: Projeto, pedido: any, permissoes: string[], estadosPermitemServicos: string[], user: any): void => {
  
  switch (acao.id) {
    case EnumMenuAcoes.FINALIZAR_PROJETO_MANUAL:
      avaliarStatusFinalizarProjetoRenovigi(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.CONFIRMA_VISITA_TECNICA:
      avaliaStatusConfirmarVisitaTecnica(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.REATIVAR:
      avaliaStatusReativar(acao, projeto, pedido, permissoes);
      break;
    case EnumMenuAcoes.FINALIZAR:
      avaliaStatusFinalizar(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.VISUALIZAR_HISTORICO:
      avaliaVisualizarHistoricoProposta(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.VISUALIZAR_PROPOSTA:
      avaliaStatusVisualizarProposta(acao, projeto, 'normal', permissoes);
      break;
    case EnumMenuAcoes.APLICAR_DESCONTO:
      avaliaStatusAplicarDesconto(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.ENVIAR_DOCUMENTO_SERVICO:
      avaliaStatusEnviarDocumentoServico(acao, projeto, pedido, permissoes);
      break;
    case EnumMenuAcoes.ENVIAR_NOTA_FISCAL_VENDA:
      avaliaStatusEnviarNotaFiscalVenda(acao, projeto, pedido, permissoes);
      break;
    case EnumMenuAcoes.PROPOSTA_SIMPLIFICADA:
      avaliaStatusVisualizarProposta(acao, projeto, 'simplificada', permissoes);
      break;
    case EnumMenuAcoes.EDITAR_SERVICO:
      avaliaStatusEditarServico(acao, projeto, permissoes, estadosPermitemServicos);
      break;
    case EnumMenuAcoes.SOLICITAR_REVISAO:
      avaliaStatusSolicitarRevisao(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.CANCELAR:
      avaliaStatusCancelar(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.ENVIAR_PAGAMENTO:
      avaliaStatusEnviarPagamento(acao, projeto, permissoes, pedido);
      break;
    case EnumMenuAcoes.EDICAO_AVANCADA:
      avaliaStatusEdicaoAvancada(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.CANCELAMENTO_ESPECIAL:
      avaliaStatusCancelamentoEspecial(acao, pedido, permissoes, user);
      break;
    case EnumMenuAcoes.CLONAR_PROJETO:
      avaliaStatusClonarProjeto(acao, projeto, permissoes);
      break;
    case EnumMenuAcoes.REENVIAR_NOTA_FISCAL:
      avaliarStatusReenviarNotaFiscal(acao, permissoes, projeto, pedido);
      break;
    case EnumMenuAcoes.ENVIAR_WHATSAPP:
      avaliarStatusEnviarWhatsapp(acao, permissoes, projeto);
      break;
    case EnumMenuAcoes.ATUALIZAR_ENTREGA:
      avaliaStatusAtualizarEntrega(acao, projeto, pedido, permissoes);
      break;
  }
}

  const avaliarStatusFinalizarProjetoRenovigi = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    if (projeto.status_projeto !== "finalizado" && PermissionUtil.can(PermissionUtil.PERMISSION_FINALIZAR_PROJETO_MANUAL, permissoes)) {
      acao.exibicao = TipoExibicao.PADRAO;
    }
  }

  const avaliaStatusConfirmarVisitaTecnica = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_CONFIRMAR_VISITA_TECNICA, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo === tipoVertical) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo !== tipoKit) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    if (projeto.data_visita_tecnica === null) {
      switch (projeto.situacao) {
          case EnumSituacaoProjeto.PENDENTE: 
              acao.exibicao = TipoExibicao.PADRAO;
              break;
      }
      if (acao.exibicao === TipoExibicao.PADRAO) { 
        switch (projeto.etapa_venda) {
            case EnumEtapaVenda.PRE_ORCAMENTO: 
                acao.exibicao = TipoExibicao.PADRAO;
                break;
            case EnumEtapaVenda.SLA_ENGENHARIA: 
                acao.exibicao = TipoExibicao.PADRAO;
                break;
            default:
                acao.exibicao = TipoExibicao.NAO_EXIBIR;
                break;
        }
      }
    } 
  } else {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
  if (acao.exibicao === TipoExibicao.PADRAO && verificaProjetoExpirado(projeto)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }

  const componentesValidos = projeto?.componentes?.filter(componente => !!componente && typeof componente === 'object' && Object.keys(componente)?.length > 0)?.filter(Boolean);
  if (!projeto?.valor_projeto && !componentesValidos?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusReativar = (acao: MenuAcao, projeto: Projeto, pedido: any, permissoes: string[]) => {
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_REATIVAR, permissoes) || projeto.situacao === 'cancelado') {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  verificaProjetoExpirado(projeto) ? acao.exibicao = TipoExibicao.PADRAO : acao.exibicao = TipoExibicao.NAO_EXIBIR;
  if (acao.exibicao === TipoExibicao.PADRAO && pedido && pedido.data_expiracao_pagamento) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  } 
}

const avaliaStatusFinalizar = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_FINALIZAR, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  acao.exibicao = TipoExibicao.NAO_EXIBIR;

  switch (projeto.status_projeto) {
    case EnumEtapaVenda.ENTREGUE:
        acao.exibicao = TipoExibicao.PADRAO;
        break;
  }
}

const avaliaVisualizarHistoricoProposta = (acao: MenuAcao, projeto: Projeto, permissoes: string[])  => {
  /*if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_HISTORICO, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }*/
  if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PROJETOS, permissoes)){
    acao.exibicao = TipoExibicao.PADRAO;
  }else if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PEDIDOS, permissoes)){
    acao.exibicao = TipoExibicao.PADRAO;
  }else if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_NOTAS_FISCAIS, permissoes)){
    acao.exibicao = TipoExibicao.PADRAO;
  }else if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_DESCONTOS, permissoes)){
    acao.exibicao = TipoExibicao.PADRAO;
  }else{
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  switch (projeto.etapa_venda) {
    case EnumEtapaVenda.SLA_ENGENHARIA: 
        acao.exibicao = TipoExibicao.NAO_EXIBIR;
        break;
  }

  const engenharia = (projeto?.engenharia || Number(projeto?.potencia) > POTENCIA_MINIMA_ENGENHARIA);
  if (projeto?.segmento?.includes('vertical') && engenharia) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusVisualizarProposta = (acao: MenuAcao, projeto: Projeto, tipo: string, permissoes: string[]) => {
  acao.exibicao = TipoExibicao.PADRAO;
  if(tipo === 'normal' && (projeto.tipo === tipoAvulso || projeto.codigo_venda?.includes("HIBRI"))){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (tipo === 'normal' && !PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (tipo === 'simplificada' && !PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  if ((projeto.componentes || []).filter(Boolean).length === 0) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR
    return;
  }

  if (verificaProjetoExpirado(projeto)) {
    acao.exibicao = TipoExibicao.PADRAO;      
  }
  if (projeto?.segmento?.includes('offgrid')) {
    if (tipo === 'normal') {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
    } else if (tipo === 'simplificada') {
      acao.exibicao = TipoExibicao.PADRAO;  
    }
  }
  if (acao.exibicao === TipoExibicao.PADRAO && tipo === 'normal') {
    if ((projeto.tipo === 'personalizado' && projeto?.tipo_faturamento !== 'cliente') || (projeto.tipo === tipoKit && projeto.quantidade_kits && projeto.quantidade_kits > 1)) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
    }
  } else if (tipo === 'simplificada') {
    if (projeto.tipo === tipoVertical) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
    } 
  }
  if (acao.exibicao === TipoExibicao.PADRAO) {
    switch (projeto.etapa_venda) {
      case EnumEtapaVenda.SLA_ENGENHARIA: 
          if (projeto && projeto.valor !== undefined && projeto.valor === 0) {
            acao.exibicao = TipoExibicao.NAO_EXIBIR;
          }
          break;
    }
  }
  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
  if (projeto?.origem === 'V1' && !!projeto?.uploads?.length) {
    const propostaV2 = projeto?.uploads?.every(i => i?.origem === 'V2');
    const origemUploads = projeto?.uploads?.find(i => i?.origem === 'V1');
    if (!origemUploads && !propostaV2) acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusEditarServico = (acao: MenuAcao, projeto: Projeto, permissoes: string[], estadosPermitemServicos: string[]) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_EDITAR_SERVICO, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.segmento?.includes(tipoVertical)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo_faturamento === "integrador_cliente"){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo_faturamento === "integrador"){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  acao.exibicao = TipoExibicao.NAO_EXIBIR;
  switch (projeto.situacao) {
      case EnumSituacaoProjeto.PENDENTE: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
  }
  if (acao.exibicao === TipoExibicao.PADRAO) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    switch (projeto.etapa_venda) {
      case EnumEtapaVenda.PRE_ORCAMENTO: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.PROPOSTA_FINAL: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.NEGOCIACAO: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.SLA_ENGENHARIA: 
          acao.exibicao = TipoExibicao.NAO_EXIBIR;
          break;
    }  
  }
  if (acao.exibicao === TipoExibicao.PADRAO) {
    if (!estadosPermitemServicos.includes(projeto?.endereco?.estado_id) && !estadosPermitemServicos.includes(projeto?.estado_id+"")) {
      acao.exibicao = TipoExibicao.DESATIVO;
    } else if ((projeto?.revenda_id === null || projeto?.revenda_id === undefined) && (projeto?.revenda === null || projeto?.revenda === undefined)) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
    } else if (projeto && projeto.valor_servico === 0 && projeto.revenda && !projeto.revenda?.segmentos_servico?.includes(projeto?.segmento?.includes("on") ? "on" : "off")) {
      acao.exibicao = TipoExibicao.DESATIVO;
    }
  }
  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusSolicitarRevisao = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_SOLICITAR_REVISAO, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  acao.exibicao = TipoExibicao.NAO_EXIBIR;        
  switch (projeto.situacao) {
      case EnumSituacaoProjeto.PENDENTE: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
  }
  if (acao.exibicao === TipoExibicao.PADRAO) {
    if (projeto?.tipo === tipoVertical) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR; 
      if (projeto?.potencia !== undefined && projeto.potencia > potMinimaSolicitarRevisaoComServ) {
        switch (projeto.etapa_venda) {
          case EnumEtapaVenda.PRE_ORCAMENTO: 
              acao.exibicao = TipoExibicao.PADRAO;
              break;
          case EnumEtapaVenda.NEGOCIACAO: 
              acao.exibicao = TipoExibicao.PADRAO;
              break;
        }  
      }
    } else {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
    }
  }
  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusAplicarDesconto = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_APLICAR_DESCONTO, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo === tipoVertical) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  acao.exibicao = TipoExibicao.NAO_EXIBIR;
  switch (projeto.situacao) {
      case EnumSituacaoProjeto.PENDENTE: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
  }
  if (acao.exibicao === TipoExibicao.PADRAO) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    switch (projeto.etapa_venda) {
      case EnumEtapaVenda.PRE_ORCAMENTO: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.PROPOSTA_FINAL: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.NEGOCIACAO: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.SLA_ENGENHARIA: 
          acao.exibicao = TipoExibicao.NAO_EXIBIR;
          break;
    }  
  }
  if (acao.exibicao === TipoExibicao.PADRAO &&  verificaProjetoExpirado(projeto)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusEnviarDocumentoServico = (acao: MenuAcao, projeto: Projeto, pedido: Pedido, permissoes: string[]) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_DOCUMENTO_SERVICO, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  acao.exibicao = TipoExibicao.NAO_EXIBIR;
  if (!!projeto?.dados_finalizar_renovigi && projeto?.valor_servico !== 0 && projeto?.servico !== TIPO_SERVICO_TURNKEY) {
    acao.exibicao = TipoExibicao.PADRAO;
    return;
  }

  switch (pedido?.situacao){
    case EnumSituacaoPedido.FINALIZADO:
      if (projeto?.valor_servico !== 0 && projeto?.servico !== TIPO_SERVICO_TURNKEY){
        acao.exibicao = TipoExibicao.PADRAO;
      }  
    break;
  }

  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusEnviarNotaFiscalVenda = (acao: MenuAcao, projeto: Projeto, pedido: Pedido, permissoes: string[]) => {
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_ENVIAR_NOTA_FISCAL_VENDA, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo_faturamento === 'integrador_cliente') {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    if(pedido && pedido?.etapa_pedido !== "envio_pagamento"){
      acao.exibicao = TipoExibicao.PADRAO;
    }
    if(acao.exibicao === TipoExibicao.PADRAO){
      switch(projeto?.status_projeto){
        case STATUS_PROJETO.CANCELADO:
          acao.exibicao = TipoExibicao.DESATIVO;
          break;
        case STATUS_PROJETO.PRE_ORCAMENTO:
          acao.exibicao = TipoExibicao.DESATIVO;
          break;
        case STATUS_PROJETO.EXPIRADO:
          acao.exibicao = TipoExibicao.DESATIVO;
          break;
        case STATUS_PROJETO.PROPOSTA_FINAL:
          if(!pedido){
            acao.exibicao = TipoExibicao.DESATIVO;
          }
          break;
      }
    }
  } else {
     acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }

  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusCancelar = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_CANCELAR, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  acao.exibicao = TipoExibicao.NAO_EXIBIR;
  switch (projeto.situacao) {
      case EnumSituacaoProjeto.PENDENTE: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
  }
  if (acao.exibicao === TipoExibicao.PADRAO) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    switch (projeto.etapa_venda) {
      case EnumEtapaVenda.PRE_ORCAMENTO: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.PROPOSTA_FINAL: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
      case EnumEtapaVenda.NEGOCIACAO: 
          acao.exibicao = TipoExibicao.PADRAO;
          break;
    }
  }
  if (acao.exibicao === TipoExibicao.PADRAO &&  verificaProjetoExpirado(projeto)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

const avaliaStatusEnviarPagamento = (acao: MenuAcao, projeto: Projeto, permissoes: string[], pedido: Pedido) => {
  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_ENVIAR_PAGAMENTO, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo === tipoVertical) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (projeto?.tipo === tipoKit) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
  } else {
    acao.exibicao = TipoExibicao.DESATIVO;
    switch (projeto.situacao) {
        case EnumSituacaoProjeto.PENDENTE: 
            acao.exibicao = TipoExibicao.PADRAO;
            break;
    }
    if (acao.exibicao === TipoExibicao.PADRAO) {
      acao.exibicao = TipoExibicao.DESATIVO;
      if (!verificaProjetoExpirado(projeto)) {
        switch (projeto.etapa_venda) {
          case EnumEtapaVenda.PRE_ORCAMENTO:
              if (projeto.data_visita_tecnica !== null){
                acao.exibicao = TipoExibicao.PADRAO;
              }
              break;
        }
      }
    }
  }
  if (pedido || ['cancelado', 'expirado', 'finalizado']?.includes(projeto.situacao)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
  }
}

export const checarStatusEditarProjeto = (projeto: Projeto, permissoes: string[], pedido:any): boolean => {
  if(projeto?.tipo === tipoAvulso){
    return false;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_EDITAR_PROJETO, permissoes)) {
    return false;
  }
  let retEditarProjeto = false;
  switch (projeto.situacao) {
    case EnumSituacaoProjeto.PENDENTE: 
        retEditarProjeto = true;
        break;
  }
  if (retEditarProjeto) {
    retEditarProjeto = false;
    switch (projeto.etapa_venda) {
      case EnumEtapaVenda.PRE_ORCAMENTO: 
        retEditarProjeto = true;
        break;
      case EnumEtapaVenda.SLA_ENGENHARIA: 
        retEditarProjeto = false;
        break;
      case EnumEtapaVenda.NEGOCIACAO: 
        retEditarProjeto = true;
        break;
        
    }
  }
  if (retEditarProjeto) {
    if (projeto?.tipo === tipoKit || 
        projeto?.tipo === tipoVertical ||
        !(projeto.codigo_venda?.includes('PROFF') || projeto.codigo_venda?.includes('PROV') || projeto.codigo_venda?.includes('PROJ') || projeto.codigo_venda?.includes('HIBRI'))) {
      retEditarProjeto = false;
    }
  }

  if (retEditarProjeto && projetoEmPropostaFinal(projeto, pedido)) {
    retEditarProjeto = false;
  }
  
  if (!projeto?.uploads?.length && projeto?.tipo === tipoVertical) {
    retEditarProjeto = false;
  }

  return retEditarProjeto;
}

const days = (date:Date) =>{
  let date_2 = new Date();
  date_2.setHours(23,59,59,999);
  date.setHours(23,59,59,999);
  let difference = date.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
}

export const verificaProjetoExpirado = (projeto: Projeto) => {
  const projetoExpirado = projeto?.situacao === 'expirado'
  const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  
  let expirado = false;
  let diasExpiracao = 0;
  if (projeto?.data_expiracao){
      if (!(moment(new Date(projeto?.data_expiracao)).format("YYYY-MM-DD") === moment(new Date()).format("YYYY-MM-DD"))){
        diasExpiracao = days(new Date(projeto?.data_expiracao))
      } 
  }
  if (projetoExpirado || (diasExpiracao < 0 && (projeto.etapa_venda === "pre_orcamento" || projeto.etapa_venda === "negociacao" || projeto.etapa_venda === "analise_financiamento"))) {
    expirado = true;
  }
  return expirado;
}

export const checarStatusDetalhesProjeto = (projeto: Projeto, permissoes: string[]): boolean => {
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_DETALHES_PROJETO, permissoes)) {
    return false;
  }
  let retEditarProjeto = true;
  if (projeto && projeto.valor !== undefined && projeto.valor === 0) {
    switch (projeto.etapa_venda) {
      case EnumEtapaVenda.SLA_ENGENHARIA: 
        retEditarProjeto = false;
        break;  
    }
  }

  if (!projeto?.uploads?.length && projeto?.tipo === 'vertical') return false;
  return retEditarProjeto;
}

export const checarStatusAcoesProjeto = (projeto: Projeto): boolean => {
  let retAcoesProjeto = true;
  if (!projeto?.uploads?.length && projeto?.tipo === 'vertical') return false;
  return retAcoesProjeto;
}

const projetoEmPropostaFinal = (projeto: Projeto, pedido:any) => {
  let emPropostaFinal = false;

  const hasVisitaConfirmada = projeto?.data_visita_tecnica !== null && projeto?.data_visita_tecnica !== undefined;
    const hasPedidoErp = pedido?.pedido_erp !== null && pedido?.pedido_erp !== undefined;
    const statusPgto = pedido?.pagamentos?.[0]?.situacao;
    if (projeto.situacao === "finalizado"){
        if (!hasPedidoErp && pedido?.pagamentos?.[0]?.situacao !== "pago"){
            //está em proposta final
            emPropostaFinal = true;
        }
    } else {
        switch (projeto.etapa_venda) {
            case "pre_orcamento":
              if (hasVisitaConfirmada){
                //está em proposta final
                emPropostaFinal = true;
              }
              break;
            case "proposta_final":
              if (statusPgto !== "pago"){
                //está em proposta final
                emPropostaFinal = true;
              }
              break;
        }
    }

  return emPropostaFinal;
}

const avaliaStatusCancelamentoEspecial = (acao: MenuAcao, pedido: Pedido, permissoes: string[], user: any) => {
  /**
   * TODO: Condicionar a exibição dessa ação por permissões gerenciadas pelo admin e não mais por ENV.
   */
  const emailsPermitidos = (process.env.REACT_APP_EMAIL_USUARIOS_CANCELAMENTO_ESPECIAL || "").split(";").filter(item => !!item);
  
  acao.exibicao = TipoExibicao.PADRAO;

  if (!pedido || !emailsPermitidos.includes(user?.email) || pedido?.situacao === 'cancelado') {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return
  }
}

const avaliaStatusClonarProjeto = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  acao.exibicao = TipoExibicao.PADRAO;

  if (projeto) {
    const tipoProjeto = projeto?.tipo;
    if(projeto?.tipo === tipoAvulso){
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
      return;
    }
    const tiposPermitidos: ProjetoTipoType[] = ["dimensionado", "personalizado"]
    if (projeto?.tipo && !tiposPermitidos.includes(projeto.tipo)) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
      return;
    }

    const projetoOnGrid = projeto.segmento && projeto.segmento.includes("ongrid")
    const projetoOffGrid = projeto.segmento && projeto.segmento.includes("offgrid")
    const projetoHibrido = projeto.codigo_venda?.includes("HIBRI")

    if (!!projetoOnGrid && !PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_CLONAR_PROJETO_ONGRID, permissoes)) {
        acao.exibicao = TipoExibicao.NAO_EXIBIR;
        return;
    }

    if (!!projetoOffGrid && !PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_CLONAR_PROJETO_OFFGRID, permissoes)) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
      return;
    }

    if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
    }

    if (!!projetoHibrido && !PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_CLONAR_PROJETO_HIBRIDO, permissoes)) {
      acao.exibicao = TipoExibicao.NAO_EXIBIR;
      return;
    }
  }
}

const avaliarStatusReenviarNotaFiscal = (acao: MenuAcao, permissoes: string[], projeto: Projeto, pedido: any) => {
  acao.exibicao = TipoExibicao.PADRAO;

  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_REENVIAR_NOTA_FISCAL, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  const notaFiscalAtiva = pedido?.notas_fiscais?.find((a: any) => a.situacao === 'ativa')
  if (!notaFiscalAtiva) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR
    return;
  }

  if (projeto?.status_projeto && !STATUS_REENVIAR_NF?.includes(projeto?.status_projeto)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
}

const avaliarStatusEnviarWhatsapp = (acao: MenuAcao, permissoes: string[], projeto: Projeto) => {
  acao.exibicao = TipoExibicao.PADRAO;

  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ENVIAR_MENSAGEM_WHATSAPP, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR
    return;
  }

  if (!projeto?.valor_projeto && !projeto?.componentes?.filter(Boolean)?.length) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  if (projeto?.tipo === tipoAvulso) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  if (!projeto.telefone_proposta) {
    acao.exibicao = TipoExibicao.DESATIVO
    return;
  }
}

const avaliaStatusEdicaoAvancada = (acao: MenuAcao, projeto: Projeto, permissoes: string[]) => {
  acao.exibicao = TipoExibicao.PADRAO;

  if(projeto?.tipo === tipoAvulso){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_EDICAO_AVANCADA, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  const dataExpiracao = Number(moment(projeto?.data_expiracao).format("x"));
  const agora = Number(moment().format("x"));

  if ((projeto?.situacao && ["expirado", "cancelado"].includes(projeto?.situacao)) || (projeto?.situacao === "pendente" && dataExpiracao < agora) || !projeto?.valor) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  if(projeto?.status_projeto && !["pre_orcamento", "proposta_final"].includes(projeto?.status_projeto)){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  // se for projeto de vertical não permiti edição avançada
  if([String(SEGMENTO_PROJETO.VERTICAL_ONGRID), String(SEGMENTO_PROJETO.VERTICAL_OFFGRID)].includes(String(projeto?.segmento)) && projeto.tipo === 'vertical'){
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }
}

const avaliaStatusAtualizarEntrega = (acao: MenuAcao, projeto: Projeto, pedido: any, permissoes: string[]) => {
  if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_ATUALIZAR_ENTREGA, permissoes)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  const notaFiscalAtiva = pedido?.notas_fiscais?.find((a: any) => a.situacao === 'ativa')
  if (!notaFiscalAtiva?.numero) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  if (projeto?.status_projeto && !STATUS_ATUALIZAR_ENTREGA?.includes(projeto?.status_projeto)) {
    acao.exibicao = TipoExibicao.NAO_EXIBIR;
    return;
  }

  acao.exibicao = TipoExibicao.PADRAO;
}
